import Accodion from "../components/ui/Accodion";
import PageTitle from "../components/ui/PageTitle";
import ContactForm from "../components/contact/ContactForm";

const faqData = [
  {
    title: "01. How does the video conferencing tool work?",
    des: "To initiate a conversation, navigate to the conversation tab and select the desired conversation type. Fill out the provided form to provide details about your conversation and its participants, enabling you to start the conversation promptly.",
  },
  {
    title: "02. How can we set up a re-occurring conversation?",
    des: "Access the Event page where you can schedule conversations to occur repeatedly with the same members and functionalities.",
  },
  {
    title: "03. Do I need to create an account to take advantage of the tool?",
    des: "Yes, having an account is necessary to access your conversations and events. Without an account, previously saved information such as name, email, and profile picture will not be retained.",
  },
  {
    title: "04. Do I need a subscription? Is this a paid application?",
    des: "No, a subscription is not required to utilize our tool. It is available for free, allowing users to take advantage of its features without any payment.",
  },
];

export default function Faq() {
  const accodions = faqData;
  return (
    <>
      <div className="faq-page-wrapper w-full mb-10">
        <div className="page-title w-full">
          <PageTitle
            title="Frequently Asked Questions"
            breadcrumb={[
              { name: "home", path: "/" },
              { name: "FAQ", path: "/faq" },
            ]}
          />
        </div>
      </div>
      <div className="contact-wrapper w-full mb-10">
        <div className="container-x mx-auto">
          <div className="main-wrapper w-full lg:flex lg:space-x-[30px]">
            <div className="lg:w-1/2 w-full">
              <h1 className="text-[22px] text-qblack font-semibold mb-1">
                Frequently asked questions
              </h1>
              <div className="flex flex-col space-y-7 justify-between">
                {accodions.map((data) => (
                  <Accodion
                    title={data.title}
                    key={data.title}
                    des={data.des}
                  ></Accodion>
                ))}
              </div>
            </div>
            <div className="flex-1">
              <ContactForm path="faq" formTitle="Have Any Question" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
